<template>
	<div class="button callout_button">
		<div @click="closedial" id="mask" class="mask"></div>
		<div class="dialog" id="mtDialog">
			<div class="dialog_head" id="move_part"><span class="tit" v-html="editDial.rTitle"></span><i @click="closedial" class="el-dialog__close el-icon el-icon-close"></i></div>
			<div class="dialog_content" @mousedown="stopPropagation($event)">
				<div v-if="!editDial.content" @mousedown="stopPropagation($event)">
					<component :is="itemMdata.tName+'Edit'" v-on:recoent="recoent" :itemMdata="itemMdata" :editDial='editDial'></component>
				</div>
				<div v-if="editDial.content">
					<textarea v-model="editDial.content" class="code"></textarea>
				</div>
			</div>
			<div class="footer_dial">
				<div class="button dialog-footer">
					<!--span class="el-button el-button--default" @click="closedial" id="close">取消</span-->
					<span class="el-button el-button--primary" @click="mSave">确认</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	let ov = {};
	let mName = ['mFontEdit', 'mImageEdit', 'circleRreaEdit', 'mCaseDesEdit', 'mPhotoDesEdit', 'graphicEdit', 'columnPictureEdit', 'multiCarouselEdit', 'articleScrapEdit', 'mNewsNavEdit', 'mNewDesEdit', 'freeContainerEdit', 'labelContainerEdit', 'newsCondiEdit', 'multiColumnContainerEdit', 'productCondiEdit', 'PhoneNavEdit', 'columnLayoutEdit', 'fullScreenEdit', 'productShowEdit', 'productSearchEdit', 'productNavEdit', 'productDesEdit', 'newlyShopEdit', 'msgSubmitEdit', 'siteFormEdit', 'serviceOnlineEdit', 'siteQrCodeEdit', 'memberLoginEdit', 'friendLinkEdit', 'areaCodeEdit', 'areaFileEdit', 'areaMapEdit', 'areaLocationEdit', 'areaIndexFavoriteEdit', 'moduleAreaNavEdit', 'sidebarEdit', 'areaFlvEdit', 'mButtonEdit', 'areaFileNavEdit', 'singlePageEdit', 'photoMoreCardEdit', 'sitemapEdit', 'mltilingualEdit', "popUpsLayoutEdit", 'zhaopinEdit', 'zhaopinDetailEdit','swiperContainerEdit','videoNavEdit', 'searchResultsEdit', 'footerNavEdit'];
	import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
	// import mButtonEdit from './frequently/mButtonEdit.vue' //编辑按钮组件
	for(let m = 0; mName.length > m; m++) {
		ov[mName[m]] = () =>
			import('../m/' + mName[m] + '.vue');
	}

	function g(id) {
		return document.getElementById(id);
	}

	//禁止选中对话框内容
	if(document.attachEvent) {
		//ie的事件监听，拖拽div时禁止选中内容，firefox与chrome已在css中设置过-moz-user-select: none; -webkit-user-select: none;
		g('mtDialog').attachEvent('onselectstart', function() {
			return false;
		});
	}

	function autoCenter(el) {
		if(!el) {
			return;
		}
		//获取可见窗口大小
		var bodyW = document.documentElement.clientWidth;
		var bodyH = document.documentElement.clientHeight;
		//获取对话框宽、高
		var elW = el.offsetWidth;
		var elH = el.offsetHeight || el.clientHeight;
		//debugger
		el.style.left = (bodyW - elW) / 2 + 'px';
		el.style.top = (bodyH - elH) / 2 + 'px';
	}
	//声明需要用到的变量
	var mx = 0,
		my = 0; //鼠标x、y轴坐标（相对于left，top）
	var dx = 0,
		dy = 0; //对话框坐标（同上）
	var isDraging = false; //不可拖动

	export default {
		name: 'uiDialog',
		components: ov,
		props: ['itemMdata', 'editDial'],
		created() {
			//console.log(this.itemMdata);
			//console.log(this.router);
			//console.log(this.footerNav);
			//debugger;
		},
		mounted: function() {
			/*
			 * window.onresize = function() {
				autoCenter(g('mtDialog'));
			};*/

			//鼠标按下
			/*g('move_part').addEventListener('mousedown', function(e) {
				var e = e || window.event;
				console.log('move_part');
				e.stopPropagation();
				mx = e.pageX; //点击时鼠标X坐标
				my = e.pageY; //点击时鼠标Y坐标
				dx = g('mtDialog').offsetLeft;
				dy = g('mtDialog').offsetTop;
				isDraging = true; //标记对话框可拖动
				document.onmousemove = function(e) {
					var e = e || window.event;
					var x = e.pageX; //移动时鼠标X坐标
					var y = e.pageY; //移动时鼠标Y坐标
					if(isDraging) {
						//判断对话框能否拖动
						var moveX = dx + x - mx; //移动后对话框新的left值
						var moveY = dy + y - my; //移动后对话框新的top值
						g('mtDialog').style.left = moveX + 'px'; //重新设置对话框的left
						g('mtDialog').style.top = moveY + 'px'; //重新设置对话框的top
						//设置拖动范围
						var pageW = document.documentElement.clientWidth;
						var pageH = document.documentElement.clientHeight;
						var dialogW = g('mtDialog').offsetWidth;
						var dialogH = g('mtDialog').offsetHeight;
						var maxX = pageW - dialogW; //X轴可拖动最大值
						var maxY = pageH - dialogH; //Y轴可拖动最大值
						moveX = Math.min(Math.max(0, moveX), maxX); //X轴可拖动范围
						moveY = Math.min(Math.max(0, moveY), maxY); //Y轴可拖动范围

						g('mtDialog').style.left = moveX + 'px'; //重新设置对话框的left
						g('mtDialog').style.top = moveY + 'px'; //重新设置对话框的top
					}
				};
			});*/

			// console.log(document.onmousemove);

			//鼠标离开
			/*
			 * document.addEventListener('mouseup', function() {
				isDraging = false;
			});
			autoCenter(g('mtDialog'));
			
			*/
		},
		methods: {
			closedial() {
				let ts = this;
				for(var v in ts.getDataCur) {
					var dataCur = ts.getDataCur[v];
					for(var j = 0; j < dataCur.length; j++) {
						var arSpon = dataCur[j];
						if(arSpon.mClass == 'Typesetting') {
							arSpon.isEdit = false;
							var itemInner = arSpon.itemInner;
							if(itemInner) {
								for(let k = 0; k < itemInner.length; k++) {
									itemInner[k].isEdit = false;
									itemInner[k].isShow = true;
								}
							} else if(arSpon.labelTitle.length) {
								for(var h = 0; h < arSpon.labelTitle.length; h++) {
									var lblinner = arSpon.labelTitle[h].itemInner;
									for(let k = 0; k < lblinner.length; k++) {
										lblinner[k].isEdit = false;
										lblinner[k].isShow = true;
									}
								}
							}
						} else {
							arSpon.isEdit = false;
						}
						//console.log(arSpon);
					}
				}
				//phoneNav.isEdit
				ts.editDial.isEdit = false;
				ts.router.langugeQx.isEdit = false;
				ts.phoneNav.isEdit = false;
				ts.footerNav.isEdit = false;

				if(ts.editDial.callBack) {
					ts.editDial.callBack();
				}
				event.stopPropagation();
			},
			recoent(itemMdata) {
				//itemMdata.isShow = true;
				//console.log(itemMdata);
				this.$emit('recoent', itemMdata);
			},
			stopPropagation(e) {
				e.stopPropagation();
				//console.log("stopPropagation");
			},
			mSave() {
				let ts = this;
				//ts.saveloca(ts.param);
				ts.closedial();
				event.stopPropagation();
			},
			...mapActions(['saveloca'])
		},
		computed: {
			...mapGetters(['getDataCur', 'phoneNav', 'footerNav', 'router'])
		},
		data() {
			return {
				rTitle: (this.editDial && this.editDial.rTitle) || '标题',
				id: this.$route.params.id,
				param: {
					id: this.$route.params.id,
					param: this.$route.params.param,
					company_id: this.$route.query.company_id,
					token: this.$route.query.token,
					column_id: this.$route.query.column_id,
					type: this.$route.query.type,
					mobile_version_id: this.$route.query.mobile_version_id,
					pc_version_id: this.$route.query.pc_version_id,
					version_id: this.$route.query.mobile_version_id
				},
				style: {
					width: (this.editDial && this.editDial.editDialWidth) || '650px',
					height: (this.editDial && this.editDial.editDialHeight) || '500px',
					border: '1px solid #BFBFBF',
					boxShadow: '0px 0px  10px 3px #bdbdbd'
				}
			};
		}
	};
</script>

<style lang="scss" scoped>
	a {
		text-decoration: none;
		color: #eee;
		display: block;
	}
	
	.dialog-footer {
		text-align: right;
		margin-right: 15px;
		margin-top: 20px;
	}
	
	.callout_button {
		background: #ff5b5b;
		margin: 0 auto;
	}
	
	.callout_button:hover {
		background: red;
	}
	
	.close_button {
		background: #363636;
		margin: 0 auto;
	}
	
	.close_button:hover {
		background: black;
	}
	
	.mask {
		min-width: 100%;
		height: 100%;
		background: #000;
		position: fixed;
		display: none;
		top: 0px;
		left: 0px;
		cursor: default;
		opacity: 0.01;
		z-index: 990;
		-moz-user-select: none;
		-webkit-user-select: none;
	}
	
	.dialog {
		position: relative;
		width: 540px;
		height: -webkit-calc(100%);
		background: #fff;
		position: fixed;
		z-index: 1000;
		padding-bottom: 10px;
		box-shadow: -2px 3px 4px #cecece;
		right: 0;
		top: 80px;
		-moz-user-select: none;
		-webkit-user-select: none;
	}
	
	.dialog_head {
		height: 50px;
		background: #4b4b4b;
		text-align: left;
		padding: 0 15px;
		.el-icon-close {
			float: right;
			margin-top: 17px;
			cursor: pointer;
		}
		line-height:50px;
		color: #eee;
	}
	
	.dialog_content {
		cursor: default;
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/t2/m/uiDialog.vue